<template>
  <div class="list">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" :model="search_form">
        <el-form-item label="申请时间">
          <date-range-picker v-model="creatTime" :value="creatTime" ref="creatTime" @getChange="dateChange"></date-range-picker>
        </el-form-item>
        <el-form-item label="费用类型">
          <el-select v-model="search_form.FFeeType" clearable class="selectWidth">
            <el-option :value="0" label="交易手续费"></el-option>
            <el-option :value="2" label="花呗贴息费"></el-option>
            <el-option :value="1" label="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发票类型">
          <el-select v-model="search_form.FInvoiceType" clearable class="selectWidth">
            <el-option :value="0" label="普通增值税发票"></el-option>
            <el-option :value="1" label="专用增值税发票"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票状态">
          <el-select v-model="search_form.FState" clearable class="selectWidth">
            <el-option :value="0" label="待审核"></el-option>
            <el-option :value="1" label="风控审核通过"></el-option>
            <el-option :value="2" label="风控审核不通过"></el-option>
            <el-option :value="3" label="开票中"></el-option>
            <el-option :value="4" label="拒绝开票"></el-option>
            <el-option :value="5" label="开票完成"></el-option>
            <el-option :value="99" label="撤销申请"></el-option>
            <el-option :value="6" label="已红冲"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户编号">
          <el-input v-model.trim="search_form.queryFMerchantId" placeholder="商户编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="发票抬头">
          <el-input v-model.trim="search_form.FInvoiceTitle" placeholder="发票抬头" clearable></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号">
          <el-input v-model.trim="search_form.FTaxpayerNum" placeholder="纳税人识别号" clearable></el-input>
        </el-form-item>
        <auth-button
          opt="search"
          :plain="true"
          @click.native="search"
          icon="el-icon-search"
          :loading="loading"
          label="查询"></auth-button>
        <auth-button opt="export" icon="el-icon-download" @click.native="exportFile" :loading="exportLoading" label="导出"></auth-button>
      </el-form>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%;"
        align="center"
        v-loading="loading"
        :data="list"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="fCreateTime"
          label="申请时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fApplyId"
          label="申请编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMerchantId"
          label="商户编号"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMerchantName"
          label="商户名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fFeeType"
          label="费用类型"
          align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fFeeType | feeType }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fFeeDetail"
          label="费用明细"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fAmount"
          label="开票金额（元）"
          align="center">
          <template slot-scope="scope">
            <span>{{ parseFloat(scope.row.fAmount / 100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fInvoiceType"
          label="发票类型"
          align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fInvoiceType === 1? '专用增值税发票': '普通增值税发票' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="开票状态"
          width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fState | recordStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="200"
          align="center">
          <!-- 未开票0可撤销开票并修改详情；开票中1不可编辑及撤销；已开票2可查看开票详情 -->
          <template slot-scope="scope">
            <auth-button
              opt="cancel_order"
              type="text"
              v-if="[0, 2, 4, 6, 99].includes(scope.row.fState)"
              label="撤销申请"
              @click.native="cancelOrder(scope.row)"></auth-button>
            <!-- <auth-button
              opt="edit"
              type="text"
              v-if="scope.row.fRecordStatus === 0"
              label="修改详情"
              @click.native="editOrder(scope.row)"></auth-button> -->
            <auth-button
              opt="details"
              type="text"
              label="查看详情"
              @click.native="checkDetails(scope.row)"></auth-button>
          </template>
        </el-table-column>
        <el-table-column
          label="发票详情"
          width="160"
          align="center">
          <template slot-scope="scope">
            <auth-button
              v-if="scope.row.fState ===5"
              opt="invoice_details"
              size="mini"
              label="查看电子发票"
              @click.native="downloadInvoice(scope.row.fUrl)"
            ></auth-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fRemark"
          label="备注"
          min-width="160"
          align="center">
          <template slot-scope="scope">
            <p class="remark" v-if="showInvoiceRemark">附加说明： <span>{{scope.row.fRemark || '-'}}</span></p>
            <p class="remark">发票备注： <span>{{scope.row.fMessage || '-'}}</span></p>
            <p class="remark">审核备注： <span>{{scope.row.fAuditRemark || '-'}}</span></p>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
    <el-dialog :visible.sync="applyDialogVisible" width="850px" title="申请开票" @close="closeViewDialog" :close-on-click-modal="false">
      <apply-form
        :visible="applyDialogVisible"
        :submit-loading="submitLoading"
        :form-data="recordFormData"
        :read-only="readOnly"
        @submit="submit"
        :showInvoiceRemark="showInvoiceRemark"></apply-form>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import applyForm from './applyForm'
import { applyInvoiceRecordList, cancelApplyInvoice, updateInvoice, invoiceExport } from '@/api/settle'
export default {
  name: 'InvoiceRecord',
  components: {
    dateRangePicker,
    pagination,
    applyForm
  },
  data () {
    return {
      loading: false,
      exportLoading: false,
      creatTime: [],
      search_form: {
        FFeeType: '', // 费用类型
        FInvoiceType: '', // 发票类型
        FState: '', // 开票状态
        FStartTime: '', // 开始时间
        FEndTime: '', // 结束时间
        queryFMerchantId: '', // 商户编号
        FInvoiceTitle: '', // 发票抬头
        FTaxpayerNum: '' // 纳税人识别号
      },
      list: [],
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      applyDialogVisible: false, // 发票弹窗是否显示
      submitLoading: false,
      recordFormData: {}, // 选中的申请记录表单
      readOnly: false,
      showInvoiceRemark: false
    }
  },
  mounted () {
    this.getList()
  },
  filters: {
    recordStatus (value) {
      let result
      switch (value) {
        case 0:
          result = '待审核'
          break
        case 1:
          result = '风控审核通过'
          break
        case 2:
          result = '风控审核不通过'
          break
        case 3:
          result = '开票中'
          break
        case 4:
          result = '拒绝开票'
          break
        case 5:
          result = '开票完成'
          break
        case 99:
          result = '撤销申请'
          break
        case 6:
          result = '已红冲'
          break
        default:
          result = '已提交'
      }
      return result
    },
    feeType (value) {
      let result
      switch (value) {
        case 0:
          result = '交易手续费'
          break
        case 2:
          result = '花呗贴息费'
          break
        default:
          result = '其他'
      }
      return result
    }
  },
  methods: {
    /**
         * @description 日期组件选中事件
         * @param  {String} value 当前结果
         */
    dateChange (value) {
      this.creatTime = value
    },
    /**
         * @description 点击查询
         */
    search () {
      this.paginations.pageNo = 1
      this.getList()
    },
    /**
         * @description 列表请求
         */
    getList () {
      this.search_form.FStartTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.search_form.FEndTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      const that = this
      that.loading = true
      const data = qs.stringify(Object.assign({}, this.search_form, this.paginations))
      applyInvoiceRecordList(data).then(response => {
        that.loading = false
        if (response.error_code === '0') {
          that.paginations.count = response.data.totalCount
          that.list = response.data.list
          that.showInvoiceRemark = response.data.agentIds && response.data.agentIds.includes(that.$store.getters.userId)
        } else {
          that.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
         * @description 清除对象中无值属性
         */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
         * @description 改变当前页事件
         * @param  {Object} value 当前结果
         */
    onChangeCurrentPage (value) {
      this.paginations.pageNo = value
      this.getList()
    },
    /**
         * @description 撤销申请
         */
    cancelOrder (row) {
      const that = this
      that.$confirm('确认撤销申请吗？', '提示', {}).then(() => {
        const param = qs.stringify({
          id: row.fId
        })
        cancelApplyInvoice(param).then(data => {
          if (data.error_code === '0') {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.getList()
          } else {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          }
        })
      })
    },
    /**
         * @description 关闭弹窗
         */
    closeViewDialog () {
      this.applyDialogVisible = false
      this.readOnly = false
    },
    /**
         * @description 编辑详情
         */
    editOrder (row) {
      this.recordFormData = row
      this.readOnly = false
      this.applyDialogVisible = true
    },
    /**
         * @description 查看详情
         */
    checkDetails (row) {
      this.recordFormData = row
      this.readOnly = true
      this.applyDialogVisible = true
    },
    /**
         * @description 发票提交事件
         * @param  {Object} form 表单对象
         * @param {String} id 当前申请编号
         */
    submit (form, id) {
      const that = this
      let param = Object.assign({
        fId: id
      }, form)
      delete param.fUpdateTime
      delete param.fCreateTime
      that.$confirm('确认提交吗？', '提示', {}).then(() => {
        that.submitLoading = true
        param = qs.stringify(that.dismissBlank(param))
        updateInvoice(param).then(data => {
          that.submitLoading = false
          if (data.error_code === '0') {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.applyDialogVisible = false
            that.getList()
          } else {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          }
        }).catch((e) => {
          this.$message({
            showClose: true,
            message: e,
            type: 'error'
          })
        })
      })
    },
    /**
         * @description 删除对象中字符串的空格
         * @param  {number} params 目标对象
         */
    dismissBlank (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key)) {
          const element = params[key]
          if (typeof element === 'string') {
            params[key] = element.replace(/ /g, '')
          }
        }
      }
      return params
    },
    /** ue
         * @description 导出文件
         */
    exportFile () {
      // eslint-disable-next-line no-unused-expressions
      this.paginations.count > 0
        ? (this.exportLoading = true, this.exportList())
        : this.$message({ showClose: true, message: '暂无数据可以导出', type: 'info' })
    },
    exportList () {
      this.search_form.FStartTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.search_form.FEndTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      const data = this.search_form
      invoiceExport(data).then(response => {
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '开票记录.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.exportLoading = false
      }, {
        axios_opts: {
          responseType: 'blob'
        }
      })
    },
    // 查看电子发票
    downloadInvoice (url) {
      window.open(url)
    }
  }
}
</script>

<style scoped lang="scss">
    .list{
        padding-left: 16px;
    }
    .pagination {
        display: inline-block;
    }
    .remark{
      text-align: left;
      span{
        color: #999;
      }
    }
</style>
